import { Injectable } from '@angular/core';
import { QuoteModel } from 'src/app/core/models/quote-model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';
import { IQuoteDismissModalData } from './quotes-modals/quotes-dismiss-quote-modal/quotes-dismiss-quote-modal.component';
import { ENUM_PERMISSIONS } from '../../../../core/enums/permission.enum';
import { PermissionMessageService } from '../../../../core/services/permission-message.service';

@Injectable({
  providedIn: 'root',
})
export class QuotesService extends BaseService<QuoteModel> {
  defaultSort = 'technicalIdentifier';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
    private permissionMessageService: PermissionMessageService,
  ) {
    super(http, 'quote', authService);
  }

  duplicate(_id: string): Observable<any> {
    return this.http.get<ObjectApiInterface<QuoteModel>>(`${this.baseUrlApi}/duplicate/${_id}`).pipe(
      map(x => {
        // this._entity.next(x.data);
        return x;
      }),
    );
  }

  sendMail(_id: string): Observable<any> {
    return this.http.get<ObjectApiInterface<QuoteModel>>(`${this.baseUrlApi}/sendMail/${_id}`).pipe(
      map(x => {
        this._entity.next(x.data);
        return x;
      }),
    );
  }

  setSelected(data: any, currentQuoteId?: string | string[]): Observable<any> {
    // Filet unique des points d'entrée « retenir/écarter un devis » (écrans devis + vérification devis du ticket).
    if (this.permissionMessageService.blockIfMissingPermission(ENUM_PERMISSIONS.UPDATE_QUOTE)) {
      return EMPTY;
    }
    return this.http.put<ObjectApiInterface<QuoteModel>>(`${this.baseUrlApi}/setSelected/${currentQuoteId}`, data).pipe(
      map(quote => {
        this._entity.next(quote.data);
        return quote;
      }),
    );
  }

  updateDescription(_id: string, description: string): Observable<any> {
    return this.http
      .put<ObjectApiInterface<QuoteModel>>(`${this.baseUrlApi}/updateDescription/${_id}`, description)
      .pipe(
        map(x => {
          this._entity.next(x.data);
          return x;
        }),
      );
  }

  checkDocumentIsNotEmpty(id: string) {
    return this.http
      .get<ObjectApiInterface<any>>(`${this.baseUrlApi}/ged/checkDocumentIsNotEmpty/${id}/QUOTE`)
      .pipe(map(x => x.data));
  }

  checkDocumentIsEmpty(id: string) {
    return this.http
      .get<ObjectApiInterface<any>>(`${this.baseUrlApi}/ged/checkDocumentIsNotEmpty/${id}/QUOTE`)
      .pipe(map(x => !x.data));
  }

  setSelectedManyQuote(data: any, currentQuoteIds?: string[]): Observable<any> {
    if (this.permissionMessageService.blockIfMissingPermission(ENUM_PERMISSIONS.UPDATE_QUOTE)) {
      return EMPTY;
    }
    return this.http
      .put<ObjectApiInterface<QuoteModel[]>>(`${this.baseUrlApi}/setSelectedManyQuote/${currentQuoteIds}`, data)
      .pipe(
        map(quote => {
          quote.data.map(quote => {
            this._entity.next(quote);
          });
          return quote;
        }),
      );
  }

  dismissQuote(_id: string, data: IQuoteDismissModalData): Observable<QuoteModel> {
    if (this.permissionMessageService.blockIfMissingPermission(ENUM_PERMISSIONS.UPDATE_QUOTE)) {
      return EMPTY;
    }
    return this.http.put<ObjectApiInterface<QuoteModel>>(`${this.baseUrlApi}/dismissQuote/${_id}`, { data }).pipe(
      map(x => {
        this._entity.next(x.data);
        return x.data;
      }),
    );
  }

  validationWithContractToUpdate(quoteId: string, contractId: string): Observable<any> {
    return this.http
      .post<ObjectApiInterface<any>>(`${this.baseUrlApi}/validationWithContractToUpdate`, {
        quoteId,
        contractId,
      })
      .pipe(
        map(quote => {
          this._entity.next(quote.data);
          return quote;
        }),
      );
  }

  engageQuoteWithContract(quoteId: string, contractId: string): Observable<any> {
    return this.http
      .post<ObjectApiInterface<any>>(`${this.baseUrlApi}/engageQuoteWithContract`, {
        quoteId,
        contractId,
      })
      .pipe(
        map(quote => {
          this._entity.next(quote.data);
          return quote;
        }),
      );
  }
}
